export default class PartsElement {
  constructor(options) {
    this.templates = {
      "add_parts": "<a id='add-build-parts' class='button secondary editor-add-parts' href=''><i class='fa fa-list'></i> add parts</a>",
      "parts_editor":  "<div class='row-fluid editor-add-parts-wrapper'>" +
                          "<h4>Parts List Maker</h4>" +
                          "<div class='part-details'>" +
                            "<div class='form-group parts-name'>" +
                              "<label for='parts-name'>Name</label>" +
                              "<input type='text' name='parts-name' />" +
                            "</div>" +
                            "<div class='form-group parts-url'>" +
                              "<label for='parts-url'>URL</label>" +
                              "<input type='text' name='parts-url' />" +
                            "</div>" +
                          "</div>" +
                          "<div class='part-details'>" +
                            "<div class='form-group parts-description'>" +
                              "<label for='parts-description'>Description</label>" +
                              "<input type='text' name='parts-description' />" +
                            "</div>" +
                            "<div class='form-group parts-quantity'>" +
                              "<label for='parts-quantity'>Quantity</label>" +
                              "<input name='parts-quantity'>" +
                            "</div>" +
                          "</div>" +
                          "<div class='clear'></div>" +
                          "<div class='editor-buttons'>" +
                            "<button class='editor-add-parts-delete delete'>Delete</button>" +
                            "<button class='editor-add-parts-cancel cancel'>Cancel</button>" +
                            "<button class='editor-add-parts-submit save'>Save</button>" +
                          "</div>" +
                          "<div class='clearfix'></div>" +
                        "</div>",
      "parts_element": "<div class='element parts-element build-parts'>" +
                          "<div class='parts-details'>" +
                            "<div>" +
                              "<span class='select2 parts-quantity'></span><span> x </span>" +
                              "<a href='#' class='parts-name'></a>" +
                              "<div class='parts-description'></div>" +
                            "</div>" +
                          "</div>" +
                          "<div class='parts-action'>" +
                            "<div>" +
                              "<a href='#' class='parts-url btn-secondary'>Buy Now</a>" +
                            "</div>" +
                          "</div>" +
                          "<div class='clearfix'></div>" +
                        "</div>"
    }

    this.options = options;

    this.learnEditor = options.editor ? options.editor : null;
    this.editor_enabled = false;
    this.code_editor;

    //used when editing parts to restore previous state on cancel
    this.saved_parts;
    this.activeElementId;
    this.activePosition;

    this.init_parts();
  }
  /* listens for the "Parts" button click, and adds the parts editor. */
  init_parts() {
    $(document).on('click', '.add-build-parts', $.proxy(this.append_parts, this));
    $(document).on('click', '.build-parts', $.proxy(this.edit_existing_parts, this));
  }

  shouldShowButton() {
    return gon.system !== "internal_learn";
  }

  addButtonTemplate() {
    return '<a class="add-build-parts" href="#"><i class="fa fa-list"></i>Part</a>';
  }

  append_parts(event, $element, parts) {
    event.preventDefault();

    //only one editor should be enabled at a time
    if (this.learnEditor.is_editor_enabled()) {
      return;
    }

    if(!$element) {
      $element = $(event.target).closest('.button-bar, .bottom-button-bar');
    }

    $element.hide();

    var $parts_editor = $(this.templates.parts_editor).hide();

    $element.replaceWith($parts_editor);

    if (parts) {
      $('.parts-name input', $parts_editor).val(parts.name.replace(/&amp;/g, "&"));
      $('.parts-url input', $parts_editor).val(parts.url);
      $('.parts-description input', $parts_editor).val(parts.description.replace(/&amp;/g, "&"));
      $('.parts-quantity input', $parts_editor).val(parts.quantity);
    }

    $parts_editor.show();

    this.learnEditor.center_in_view($parts_editor);
    this.learnEditor.editing();
    this.enable_parts_editor();
  }

  edit_existing_parts(event) {
    event.preventDefault();

    //only one editor should be enabled at a time
    if (this.learnEditor.is_editor_enabled()) {
      return;
    }

    this.activeElementId = $(event.currentTarget).attr('id');
    this.activePosition = $(event.currentTarget).data('position');
    this.saved_parts = this.parse_parts_from_element($(event.currentTarget));

    this.append_parts(event, $(event.currentTarget), this.saved_parts);
  }

  enable_parts_editor() {
    $('.editor-add-parts-wrapper').on('click', '.editor-add-parts-submit', $.proxy(this.save_parts_handler, this));
    $('.editor-add-parts-wrapper').on('click', '.editor-add-parts-cancel', $.proxy(this.cancel_parts_handler, this));
    $('.editor-add-parts-wrapper').on('click', '.editor-add-parts-delete', $.proxy(this.delete_parts_handler, this));
    // enable select2 for the code selection list
    $('.select2').select2({
      width: 'resolve'
    })
  }

  parts_editor_modified() {
    $(document).off('click', '.editor-add-parts-submit');
    $(document).off('click', '.editor-add-parts-cancel');
    $(document).off('click', '.editor-add-parts-delete');

    this.saved_parts = null;
    this.learnEditor.save_page("Before Parts Modified");
  }

  parse_parts_from_element($element) {
    var parts = {
      name: $('.parts-name', $element).html(),
      url: $('.parts-url', $element).attr('href'),
      description: $('.parts-description', $element).html(),
      quantity: $('.parts-quantity', $element).html()
    };

    return parts;
  }

  parse_parts_from_editor() {
    var $parts_editor = $('.editor-add-parts-wrapper');

    var parts = {
      name: $('.parts-name input', $parts_editor).val(),
      url: $('.parts-url input', $parts_editor).val(),
      description: $('.parts-description input', $parts_editor).val(),
      quantity: $('.parts-quantity input', $parts_editor).val()
    };

    return parts;
  }

  validate_parts_element(parts) {
    for (var key in parts) {
      if (parts[key].length <= 0 && key != 'url') {
        alert('Please populate the part ' + key + ' prior to saving');
        return false;
      }

      if (isNaN(parts["quantity"])) {
        alert('Please enter a numerical value for quantity');
        return false;
      }


    }

    return true;
  }

  save_parts_handler(event) {
    event.preventDefault();

    var parts = this.parse_parts_from_editor();

    if (this.validate_parts_element(parts)) {
      this.create_parts_element(parts);
    }
  }

  cancel_parts_handler(event) {
    event.preventDefault();

    // replace parts and show previous values

    if (this.saved_parts) {
      this.create_parts_element(this.saved_parts);
    } else {
      $('.editor-add-parts-wrapper').remove();
    }

    this.learnEditor.finishEditing();
  }

  delete_parts_handler(event) {
    event.preventDefault();

    this.activeElementId = "";
    this.activePosition = "";
    $(event.currentTarget).closest('.editor-add-parts-wrapper').remove();
    this.parts_editor_modified()
  }

  create_parts_element(parts) {
    var $parts_element = this.renderPartsElement();

    if (parts.url) {
      $('.parts-url, .parts-name', $parts_element).attr('href', parts.url);
      $('.parts-name', $parts_element).html(parts.name);
    } else {
      $('.parts-url', $parts_element).remove();
      $('.parts-name', $parts_element).replaceWith("<span class='parts-name'>" + parts.name + "</span>");
    }
    $('.parts-description', $parts_element).html(parts.description);
    $('.parts-quantity', $parts_element).html(parts.quantity);

    $('.editor-add-parts-wrapper').replaceWith($parts_element);
    this.parts_editor_modified()
  }

  renderPartsElement() {
    var template = $(this.templates.parts_element).attr('id', (this.activeElementId || "")).data('position', this.activePosition);
    this.activeElementId = "";
    this.activePosition;
    return template;
  }
}
